export const config = {
  src: [
    'audiosprites/audio.ogg',
    'audiosprites/audio.mp3',
  ],
  sprite: {
    big_win: [
      0,
      5632.2902494331065,
    ],
    button_spin: [
      7000,
      677.7324263038552,
    ],
    end_free_spin: [
      9000,
      4337.777777777777,
    ],
    free_bet_big_win: [
      15000,
      1377.2335600907013,
    ],
    free_bet_mega_win: [
      18000,
      2213.151927437643,
    ],
    free_bet_total_win: [
      22000,
      979.591836734695,
    ],
    free_bet_ultra_win: [
      24000,
      1319.1836734693893,
    ],
    free_spin_ambient: [
      27000,
      26498.32199546485,
    ],
    free_spin_music: [
      55000,
      41740.770975056694,
    ],
    free_spin_popup: [
      98000,
      4633.832199546489,
    ],
    free_spin_start: [
      104000,
      5437.8231292516975,
    ],
    inside_buttons: [
      111000,
      451.3378684807208,
    ],
    main_ambient: [
      113000,
      79496.41723356009,
    ],
    main_music: [
      194000,
      177391.74603174604,
    ],
    mega_win: [
      373000,
      5466.848072562357,
    ],
    outside_buttons: [
      380000,
      358.45804988662167,
    ],
    reel_spin: [
      382000,
      2533.877551020396,
    ],
    reel_stop_01: [
      386000,
      210.43083900224246,
    ],
    reel_stop_02: [
      388000,
      222.04081632651196,
    ],
    reel_stop_03: [
      390000,
      207.5283446711751,
    ],
    reel_stop_04: [
      392000,
      210.43083900224246,
    ],
    reel_stop_05: [
      394000,
      242.35827664398357,
    ],
    regular_win: [
      396000,
      1661.6780045351334,
    ],
    tap_to_play: [
      399000,
      6236.009070294813,
    ],
    ultra_win: [
      407000,
      4860.226757369617,
    ],
  },
}
